import { render } from "./Friends.vue?vue&type=template&id=2b87b93a"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/Friends.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b87b93a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b87b93a', __exports__)) {
    api.reload('2b87b93a', __exports__)
  }
  
  module.hot.accept("./Friends.vue?vue&type=template&id=2b87b93a", () => {
    api.rerender('2b87b93a', render)
  })

}


export default __exports__